import heic2any from 'heic2any';
export const convertToWebP = async (file) => {
    if (!file) {
        throw new Error("No file provided");
    }

    const validImageTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/heic", "image/heif"];
    if (!validImageTypes.includes(file.type)) {
        throw new Error("Invalid file type. Please provide an image file.");
    }

    let blobToConvert = file;
    if (file.type === "image/heic" || file.type === "image/heif") {
        try {
            blobToConvert = await heic2any({
                blob: file,
                toType: "image/jpeg",
                quality: 0.5,
            });
        } catch (error) {
            throw new Error("Error converting HEIC/HEIF file: " + error.message);
        }
    }
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                try {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    canvas.width = img.width;
                    canvas.height = img.height;

                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob(
                        (webpBlob) => {
                            if (webpBlob) {
                                const convertedFile = new File([webpBlob], `${file.name.split(".")[0]}.webp`, {
                                    type: "image/webp",
                                });
                                resolve(convertedFile);
                            } else {
                                reject(new Error("Failed to convert image to WebP"));
                            }
                        },
                        "image/webp", // MIME type for WebP
                        0.8
                    );
                } catch (error) {
                    reject(new Error("Error during image processing: " + error.message));
                }
            };

            img.onerror = () => {
                reject(new Error("Error loading image for WebP conversion."));
            };
        };
        reader.onerror = () => {
            reject(new Error("Error reading the file."));
        };

        reader.readAsDataURL(blobToConvert);
    });
};

export const resizeImage = (img, targetWidth, targetHeight) => {
    return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const scale = Math.min(targetWidth / img.width, targetHeight / img.height);
        const newWidth = img.width * scale;
        const newHeight = img.height * scale;

        const xOffset = (targetWidth - newWidth) / 2;
        const yOffset = (targetHeight - newHeight) / 2;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, xOffset, yOffset, newWidth, newHeight);

        canvas.toBlob((blob) => {
            if (blob) {
                resolve(new File([blob], "resized-image.png", { type: "image/png" }));
            } else {
                reject(new Error("Error resizing image"));
            }
        }, "image/png", 0.9);
    });
};

